const parseDateTime = (value: string): Date => {
  return new Date(value.replace(' ', 'T'));
};

const parseDate = (value: string | null): Date | null => {
  return value ? new Date(`${value}T00:00:00`) : null;
};

export const mapSelfIpoOfferingFromApi = (
  resp: ApiSelfIpoOffering
): SelfIpoOffering => {
  return {
    id: resp.id,
    tickerCode: resp.ticker_code,
    companyName: resp.company_name,
    coverImageUrl: resp.cover_image_url,
    description: resp.description ?? null,
    sector: resp.sector,
    tags: resp.tags,
    priceLow: resp.price_low,
    priceHigh: resp.price_high,
    minAmount: resp.min_amount,
    dealFee: resp.deal_fee,
    successFee: resp.success_fee,
    lockUp: resp.lock_up,
    status: resp.status,
    acceptanceDeadline: parseDateTime(resp.acceptance_deadline),
    secondsToDeadline: resp.seconds_to_deadline ?? 0,
    isAccepting: resp.is_accepting ?? false,
    applicationCount: resp.application_count ?? 0,
  };
};

export const mapSelfIpoApplicationFromApi = (
  resp: ApiSelfIpoApplication
): SelfIpoApplication => {
  return {
    id: resp.id,
    offeringId: resp.offering_id,
    amount: resp.amount,
    status: resp.status,
    submittedAt: parseDateTime(resp.submitted_at),
    allocationPercent: resp.allocation_percent,
    allocatedAmount: resp.allocated_amount,
    buyPrice: resp.buy_price,
    buyQuantity: resp.buy_quantity,
    buyDate: parseDate(resp.buy_date),
    unlockDate: parseDate(resp.unlock_date),
    isUnlocked: resp.is_unlocked,
    profitPercent: resp.profit_percent,
    fixedProfitPercent: resp.fixed_profit_percent,
    dealFee: resp.deal_fee,
    successFee: resp.success_fee,
    lockUp: resp.lock_up,
    canCancel: resp.can_cancel ?? false,
    offering: resp.offering ? mapSelfIpoOfferingFromApi(resp.offering) : null,
  };
};

export const mapSelfIpoEligibilityFromApi = (
  resp: ApiSelfIpoEligibility
): SelfIpoEligibility => {
  return {
    status: resp.status,
    message: resp.message,
  };
};

export const mapSelfIpoPortfolioFromApi = (
  resp: ApiSelfIpoPortfolio
): SelfIpoPortfolio => {
  return {
    id: resp.id,
    cashBalance: resp.cash_balance,
    holdBalance: resp.hold_balance,
    assetBalance: resp.asset_balance,
    balance: resp.balance,
  };
};

export const mapSelfIpoOfferingDetailFromApi = (
  resp: ApiSelfIpoOfferingDetailResponse
): SelfIpoOfferingDetail => {
  const myApplication = resp.my_application ?? resp.myApplication ?? null;

  return {
    item: mapSelfIpoOfferingFromApi(resp.item),
    myApplication: myApplication
      ? mapSelfIpoApplicationFromApi(myApplication)
      : null,
    eligibility: mapSelfIpoEligibilityFromApi(resp.eligibility),
  };
};
